import { IconConverter } from '../utils/IconConverter';

export class CustomMeal {
  constructor(mealString) {
    this.name = '';
    this.id = '';
    this.icon = '';
    this.categories = [];

    if (mealString) {
      const parts = mealString.split(':');
      if (parts.length > 0) this.name = parts[0].trim();
      if (parts.length > 1) this.id = parts[1].trim();
      if (parts.length > 2) this.icon = parts[2].trim();
      if (parts.length > 3) this.categories = parts[3].trim().split(',');
    }
  }

  getIconName() {
    // Convert SF Symbol to Material Icon
    return IconConverter.sfToMaterial(this.icon) || 'restaurant';
  }

  getDescription() {
    return this.name || '';
  }

  toString() {
    return `${this.name}:${this.id}:${this.icon}:${this.categories.join(',')}`;
  }
} 